import React from 'react';
import { Link } from 'react-router-dom';

// תמונות
import serviceHeroImage from '../assets/images/service-hero.jpg';
import solderingImage from '../assets/images/soldering.jpg';
import laserImage from '../assets/images/laser.jpg';
import developmentImage from '../assets/images/development.jpg';

const Services = () => {
  const services = [
    {
      title: 'הלחמות מקצועיות',
      description: 'שירותי הלחמה מתקדמים ומדויקים',
      image: solderingImage,
      items: [
        'הלחמות SMT/TH/FINE PITCH',
        'הלחמות BGA ברמה אזרחית/צבאית',
        'עבודה תחת מיקרוסקופ',
        'תיקוני הלחמות עדינות'
      ],
      icon: (
        <svg className="w-12 h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 3v2m6-2v2M9 19v2m6-2v2M5 9H3m2 6H3m18-6h-2m2 6h-2M7 19h10a2 2 0 002-2V7a2 2 0 00-2-2H7a2 2 0 00-2 2v10a2 2 0 002 2zM9 9h6v6H9V9z" />
        </svg>
      )
    },
    {
      title: 'עבודות לייזר',
      description: 'שימוש בטכנולוגיית לייזר מתקדמת',
      image: laserImage,
      items: [
        'ריתוכי לייזר מדויקים',
        'חיתוכי לייזר',
        'סימון לייזר',
        'עבודות לייזר מותאמות אישית'
      ],
      icon: (
        <svg className="w-12 h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
        </svg>
      )
    },
    {
      title: 'שירותי פיתוח',
      description: 'ליווי מקצועי בתהליכי פיתוח',
      image: developmentImage,
      items: [
        'הרכבת מעגלי PROTOTYPE',
        'עבודה מול מחלקות פיתוח',
        'תיעוד ושרטוטים',
        'ייעוץ טכני'
      ],
      icon: (
        <svg className="w-12 h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z" />
        </svg>
      )
    }
  ];

  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <div className="gradient-primary text-white relative overflow-hidden py-16">
        {/* תמונת רקע */}
        <div className="absolute inset-0">
          <img 
            src={serviceHeroImage} 
            alt="שירותי הלחמה" 
            className="w-full h-full object-cover opacity-20"
          />
        </div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">השירותים שלנו</h1>
          <p className="text-xl max-w-3xl mx-auto">
            מגוון רחב של שירותי הלחמה מקצועיים ומתקדמים, מותאמים לצרכים שלכם
          </p>
        </div>
      </div>

      {/* Services Grid */}
      <div className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {services.map((service, index) => (
              <div key={index} className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow">
                {/* תמונת השירות */}
                <div className="relative h-48 overflow-hidden">
                  <img 
                    src={service.image} 
                    alt={service.title} 
                    className="w-full h-full object-cover transform hover:scale-110 transition-transform duration-300"
                  />
                </div>
                <div className="p-6">
                  <div className="text-primary-600 mb-4">
                    {service.icon}
                  </div>
                  <h3 className="text-2xl font-semibold mb-2">{service.title}</h3>
                  <p className="text-gray-600 mb-4">{service.description}</p>
                  <ul className="space-y-2">
                    {service.items.map((item, idx) => (
                      <li key={idx} className="flex items-start">
                        <svg className="w-5 h-5 text-primary-500 mt-1 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                        </svg>
                        <span className="text-gray-700">{item}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* CTA Section */}
      <div className="bg-primary-50 py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl font-bold text-primary-900 mb-4">מעוניינים בשירותים שלנו?</h2>
          <p className="text-xl text-primary-700 mb-8">צרו איתנו קשר לקבלת הצעת מחיר מותאמת אישית</p>
          <Link 
            to="/contact" 
            className="inline-block bg-primary-600 text-white px-8 py-3 rounded-lg text-lg font-semibold hover:bg-primary-700 transition-colors"
          >
            צור קשר עכשיו
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Services; 